export default {
  domain: 'shoplink.auth0.com',
};
